import React from 'react';

import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';
import SkeletonImg from 'Components/Skeleton/SkeletonImg';
import fluidSizesSources from 'Components/Skeleton/fluidSizesSources';

// ProductCover's sizesOverride in ProductHeader, so the skeleton requests the cover URLs the page will. Below md
// that's the only cover; from md up the carousel's sizes pick the same widths
const COVER_SIZES = '(min-width: 1520px) 870px, (min-width: 1200px) 740px, (min-width: 992px) 620px, (min-width: 768px) 704px, 98vw';
const coverSources = fluidSizesSources(COVER_SIZES, 16 / 9);

/**
 * Product page while it loads: the header from ProductView (name, reviews, media carousel and buy panel).
 * Slots: `name` (text), `cover` (image URL).
 */
export default function ProductPageSkeleton() {
  return (
    <div className="ProductPageSkeleton">
      <header className="ProductPageSkeleton__header">
        <div className="ProductPageSkeleton__slash" />

        <section className="container">
          <SkeletonBlock text tag="h1" slot="name" className="ProductPageSkeleton__name" />
          <SkeletonBlock className="ProductPageSkeleton__reviews d-none d-sm-block" />
        </section>

        <section className="container ProductPageSkeleton__main">
          <div className="ProductPageSkeleton__carousel">
            <div className="responsive-image responsive-image--16by9 ProductPageSkeleton__cover">
              <SkeletonImg slot="cover" sizes={COVER_SIZES} sources={coverSources} className="img-force-full" />
            </div>
          </div>

          <div className="ProductPageSkeleton__details">
            <SkeletonBlock className="ProductPageSkeleton__icons" />
            <SkeletonBlock className="ProductPageSkeleton__tags" />
            <SkeletonBlock className="ProductPageSkeleton__price" />
            <SkeletonBlock className="ProductPageSkeleton__button" />
          </div>
        </section>
      </header>
    </div>
  );
}
